export const statusData = [
  { label: 'Hoạt động', value: 'active' },
  { label: 'Dừng hoạt động', value: 'inactive' }
];

export const typeData = [
  { label: 'Dùng 1 lần', value: 'one_time' },
  { label: 'Dùng nhiều lần', value: 'multiple_time' }
];